const paths = {
  locationsList: '/locations/list',
  importLocations: '/locations/import'
};

export default paths;
